import "./MobNavbar.css";
import {Link} from "react-router-dom";
import {BsFillMoonStarsFill} from "react-icons/bs";
import {MdOutlineLightMode} from "react-icons/md";
import React from "react";

function MobNavbar(props) {
    return (
        <div className="mob-main">
            <div class="nav-bar" style={{backgroundColor: props.darkMode?"rgb(17 24 39)":"darkcyan"}}>
                <div class="head-flex">
                    <div></div>
                    <h1 class="head">Gaurav Sharma</h1>
                    {props.darkMode ?
                        <BsFillMoonStarsFill
                            onClick={() => props.setDarkMode(!props.darkMode)}
                            className=" cursor-pointer text-2xl"
                            style={{color: "white", fontSize: "1.7rem"}}
                        />
                        : <MdOutlineLightMode
                            onClick={() => props.setDarkMode(!props.darkMode)}
                            className=" cursor-pointer text-2xl"
                            style={{color: "black", fontSize: "2rem"}}
                        />
                    }
                </div>
                <div class="box-contents">
                    <Link style={{textDecoration: "none"}} to="/">
                        <span>HOME</span>
                    </Link>
                    <Link style={{textDecoration: "none"}} to="#aboutMe">
                        <span>ABOUT</span>
                    </Link>
                    <Link style={{textDecoration: "none"}} to="#Projects">
                        <span>PROJECTS</span>
                    </Link>
                    {/*<Link style={{ textDecoration: "none" }} to="/blog">*/}
                    {/*  <span>CONTACT</span>*/}
                    {/*</Link>*/}
                </div>
            </div>
        </div>
    );
}

export default MobNavbar;
